import { WalletCountries } from '@/components/ui/WalletBalance';

export type WalletHistoryProps = {
  id?: string;
  wallet?: number | number[]; // Can be single wallet ID or array of wallet IDs
  operationTypes?: number[];
  walletCountries?: WalletCountries;
  start?: string;
  end?: string;
  title?: string;
  headerClass?: string;
  rowColorPositive?: string;
  rowColorNegative?: string;
  amountColorPositive?: string;
  amountColorNegative?: string;
};

export const defaults = {
  id: undefined,
  operationTypes: [],
  walletCountries: [],
  start: null,
  end: null,
  wallet: null,
  title: '',
  headerClass: 'bg-primary',
  rowColorPositive: '#ffffff',
  rowColorNegative: '#ffffff',
  amountColorPositive: '#454545de',
  amountColorNegative: '#454545de',
};
